import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav `
  /** value of rgba(brand.green, 0.4), hex needed for hover state */
  --colorInactive: #ced6cb;
  --colorActive: ${brand.green};
  --clickPadding: 24px;
  --height: 2px;
  --width: 20px;
  --fill: 0;

  display: flex;
  flex-direction: row;
  place-content: center;
  place-items: center;
  user-select: none;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 24px;
    left: 0;
    height: var(--height);
    width: 100%;
    background-color: var(--colorInactive);
  }

  @media ${from(Device.Tablet)} {
    --width: 100px;
    --height: 4px;
  }

  &[data-exclude-fill='true'] {
    --colorInactive: none;
  }
`;
const Fill = styled.div `
  position: absolute;
  z-index: 1;
  top: 24px;
  left: 0;
  height: var(--height);
  width: 100%;
  background-color: var(--colorActive);
  transform: scaleX(var(--fill));
  transform-origin: left;
  ${transition('transform')};

  [data-exclude-fill='true'] & {
    display: none;
  }
`;
const Item = styled.button `
  flex: 1;
  position: relative;
  z-index: 2;
  display: flex;
  background: none;
  border: 0;
  color: transparent;
  margin: 0;
  padding: var(--clickPadding) 0;
  place-content: center;
  place-items: center;
  ${transition('color')};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;

  &::before {
    content: '';
    display: block;
    background-color: var(--colorInactive);
    border: 0;
    height: 0;
    width: 100%;
    ${transition('transform')};
    position: absolute;
    top: 50%;
  }

  &[data-passed='true']::before {
    background-color: var(--colorActive);
  }

  &:hover::before {
    height: var(--height);
    transform: scaleY(3);
  }
`;
const DotPaginationStyles = {
    Container,
    Fill,
    Item,
};
export default DotPaginationStyles;
